import React, { Fragment, useState } from "react";
import { useQuery } from "react-query";
import ModuleManagementTable from "./ModuleManagementTable";
import { getAllModule } from "../../../../actions/Utilities/ModuleManagement";
import { store } from "react-notifications-component";
import { toast } from "../../../../components/toastNotification";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Sidebar from "../../../CarrierAgreementMgmt/Reports/Sidebar";

const ModuleManagement = ({ children }) => {
  const [ModuleData, setModuleData] = useState([]);

  useQuery("AllModule", getAllModule, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (res) {
        if (res.statusCode === 500 || res.statusCode === 400) {
          store.addNotification(
            toast.fire("Server Error", "Cannot display data", "error")
          );
        } else {
          setModuleData(
            res.map((responseData) => {
              return {
                ...responseData,
              };
            })
          );
        }
      } else {
        store.addNotification(
          toast.fire("No Data:", "No available data to display.", "info")
        );
      }
    },
  });

  return (
    <Router>
      <Fragment>
        <div className="flex">
          <Sidebar />
          <Fragment>
            <Switch>
              <Route
                path="/utilities/usermanagement"
                exact
                component={ModuleManagement}
              />
            </Switch>
          </Fragment>
          <div className="grid grid-cols-1 space-x-8 -mx-8 p-8">
            <div className="space-y-5  box-shadow">
              <div className="animate-fade-in-down space-y-5 px-4">
                <div className="uppercase text-primary -mb-4 font-bold p-1 pt-2">
                  Module Management
                </div>
                <hr className="borderSecondary"></hr>
              </div>
              <div className="flex justify-between text-xs items-center w-full px-8 pb-4 2xl:w-96">
                <div className="w-full ">
                  {/* <MultiSelectInput
                      options={adminUserSelect}
                      value={selectedAdminUser}
                      handleMultiSelect={handleMultiStateSelectForAdmin}
                    /> */}
                </div>
                <div className="mr-1 ">
                  {/* <SearchButton
                      buttonValue="Search"
                      onClick={() => handleSearchAdmin()}
                    /> */}
                </div>
                <div className=" ">
                  {/* <RefreshButton onClick={() => resetFilterAdmin()} /> */}
                </div>
              </div>
              <ModuleManagementTable ModuleData={ModuleData} />
            </div>
          </div>
        </div>
      </Fragment>
    </Router>
  );
};
export default ModuleManagement;
